'use client';

import { Skeleton } from '@repo/ui/skeleton';
import React from 'react';

/**
 * Skeleton loader for DepositCryptoDetails component
 */
const DepositCryptoDetailsSkeleton: React.FC = () => (
  <div className="flex h-full w-full flex-col items-center justify-between space-y-4 self-center py-4 animate-in fade-in sm:max-w-[450px]">
    {/* Select fields (coin & network) */}
    <div className="flex w-full items-center justify-between gap-2 px-2">
      {/* currency select (mobile only) */}
      <Skeleton className="h-10 w-1/3 rounded sm:hidden" />
      {/* network select */}
      <Skeleton className="h-10 flex-1 rounded" />
    </div>

    {/* QR code */}
    <div className="flex justify-center">
      <div className="rounded p-1">
        <Skeleton className="h-[130px] w-[130px] rounded" />
      </div>
    </div>

    {/* Address & copy */}
    <div className="flex w-full flex-col items-center justify-center space-y-1 px-2">
      <div className="flex w-full items-center space-x-2 rtl:space-x-reverse">
        {/* address field */}
        <Skeleton className="h-12 flex-1 rounded" />
        {/* copy button */}
        <Skeleton className="h-12 w-20 rounded-full" />
      </div>
    </div>

    {/* description */}
    <div className="flex w-full items-center justify-center px-2">
      <Skeleton className="h-4 w-full rounded" />
    </div>
  </div>
);

export default React.memo(DepositCryptoDetailsSkeleton);
